import React from 'react';
import Layout from '../../components/Layout';
import Order from './Order';
import { getOrder } from '../../actions/basket';
import { getPagePresentationKeys } from '../../actions/page';
import { SALES_CHANNELS, DEFAULT_PAGE_TITLE, SHOP_PATH } from '../../constants';
import { getSalesChannelById } from '../../actions/config';
import { urlPrefix } from '../../helpers';
import { hasSpecialCharacters } from '../../helpers/validator';

const pageName = 'orderConfirmation'; // todo change probably

async function action({ store }, { id }) {
  const hasSplChar = hasSpecialCharacters(id);
  if (hasSplChar) {
    return undefined;
  }
  const {
    byName: {
      [pageName]: { pageTitle, pageDescription },
    },
  } = await store.dispatch(getPagePresentationKeys({ pageName }));
  const { intl: { locale, countryCode, currency } = {} } = store.getState();
  const response = await store.dispatch(getOrder(id.toUpperCase()));
  if (response?.error) {
    return {
      redirect: urlPrefix(SHOP_PATH, {
        countryCode,
        locale,
        currency,
      }),
    };
  }
  const orderSalesChannel = response?.salesChannel?.id;
  let logoUrl = null;
  let showWhiteLabelLogoUrl = false;
  if (orderSalesChannel && orderSalesChannel !== SALES_CHANNELS.B2C) {
    const salesChannel = await store.dispatch(
      getSalesChannelById(orderSalesChannel),
    );

    if (salesChannel?.showWhiteLabelLogoUrl) {
      logoUrl = salesChannel?.logoUrl;
      showWhiteLabelLogoUrl = true;
    }
  }

  return {
    chunks: ['order'],
    title: pageTitle || DEFAULT_PAGE_TITLE,
    description: pageDescription,
    component: (
      <Layout
        showWhiteLabelLogoUrl={showWhiteLabelLogoUrl}
        logoUrl={logoUrl}
        footerBar
      >
        <Order />
      </Layout>
    ),
    salesChannelId: SALES_CHANNELS.REDEEM,
    addCompanyMarkup: true,
  };
}

export default action;
